import ReactVisibilitySensor from "react-visibility-sensor"
import BorderLeftCardPropsType from "../../types/BorderLeftCardPropsType"
import Counter from "../Counter/Counter"
import { useContext } from "react"
import { LangContext } from "../../App"

const BorderLeftCard = ({ title, subtitle, titleTwo, subtitleTwo, number, } : BorderLeftCardPropsType ) => {
  const { lang } = useContext(LangContext);

  return (
    <ReactVisibilitySensor
      partialVisibility
    >
      {({isVisible} : any) => (
        <div className={`border-left-card ${lang === 0 ? "" : "rtl"} ${isVisible ? "visible" : ""}`}>
            {number ? <h3 className="title"><Counter counterValue={number.value} applyCounteClassName={"title"} />{number.unit}</h3> : ""}
            {title ? <h3 className={`title`}>{title}</h3> : ""}
            {subtitle ? <p className={`subtitle`}>{subtitle}</p> : ""}
            {titleTwo ? <h3 className={`title`}>{titleTwo}</h3> : ""}
            {subtitleTwo ? <p className={`subtitle`}>{subtitleTwo}</p> : ""} 
        </div>
      )}
    </ReactVisibilitySensor>
  )
}

export default BorderLeftCard